import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import Navbar from "./Layout/Navbar";
import Footer from "./Layout/Footer";
import Home from "./Home";
import CourseDetails from "./CourseDetails";
import FreeDemo from "./FreeDemo";
import Gallery from "./Gallery";

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <div className="app-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />

          <Route path="/courses/:courseId" element={<CourseDetails />} />
          <Route path="/free-demo" element={<FreeDemo />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </div>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
